const init = () => {
    return class R_Repeat {
        constructor(obj) {
            this._interval = obj.interval || 0;
            this._lastX = 0;
            this._count = 0;
            this._noflag = !!obj.noflag;

            if (obj.count) { // 횟수 반복
                this._goalCount = obj.count;
                this._loop = false;
            } else { // 무한 반복
                this._goalCount = null;
                this._loop = true;
            }
        }

        // 오브젝트 세트 간 gridX 간격
        get interval() { return this._interval + this._lastX; }

        set interval(interval) { this._interval = interval; }

        // 반복 횟수
        get count() { return this._count; }

        set count(count) { this._count = count; }

        // 오브젝트 세트의 길이
        get lastX() { return this._lastX; }

        set lastX(lastX) { this._lastX = lastX; }

        // 무한 반복 여부
        get loop() { return this._loop; }

        // 반복 종료 여부
        get repeatEnded() { return !this._loop && this._count >= this._goalCount; }

        get noFlag() { return this._noflag; }

        /**
         * [ Function :: isEnded ]
         *
         * @DES :: 모든 세트가 완전히 지나갔는지
         * @IP1 :: moveCnt {number}
         * @O.P :: {boolean}
         */
        isEnded(moveCnt) {
            return !this._loop && moveCnt === this.interval * this._goalCount + this.lastX;
        }

        isLast() {
            return this._goalCount - this.count === 1;
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/attr/R_Repeat.js